import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { TBooleanInNumber } from 'src/types/main';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps {
  skeleton?: boolean;
  disabled?: boolean;
  isDelete?: TBooleanInNumber;
  iconSize?: number;
  iconClassName?: string;
  hideTooltip?: () => void;
  onRestore?: () => void;
  onDelete?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const DeleteRestoreBlock: React.FC<IProps> = (props: IProps): JSX.Element => {
  const handleRestore = () => {
    if (props.disabled) {
      if (props.hideTooltip) props.hideTooltip();
      return;
    }

    if (props.onRestore) props.onRestore();
  };

  if (props.skeleton) return <Skeleton width={24} height={24} />;

  return props.isDelete ? (
    <button onClick={handleRestore} className={classNames('delete-restore-block__btn-restore px-0', { disabled: props.disabled })}>
      <p className="family-medium text-size-16 color-mainblue">{localeStore.t('restore')}</p>
    </button>
  ) : (
    <Icon
      onPress={props.onDelete}
      name={Icons.Trash}
      size={props.iconSize || 24}
      disabled={props.disabled}
      className={classNames('delete-restore-block__btn-delete', props.iconClassName)}
      disabledClassName="delete-restore-block__btn-delete_disabled"
    />
  );
};

export default DeleteRestoreBlock;
